module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "选择店铺",
      "visible": _vm.showModal,
      "width": "500px",
      "append-to-body": "",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      }
    }
  }, [_c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('el-input', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "placeholder": "店铺名称",
      "clearable": ""
    },
    on: {
      "clear": _vm.handleClear
    },
    model: {
      value: (_vm.params.name),
      callback: function($$v) {
        _vm.$set(_vm.params, "name", $$v)
      },
      expression: "params.name"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.handleKeySearch
    },
    slot: "append"
  })], 1), _vm._v(" "), _c('el-cascader', {
    attrs: {
      "placeholder": "根据地区筛选",
      "options": _vm.regions,
      "filterable": "",
      "clearable": "",
      "props": {
        checkStrictly: true
      }
    },
    on: {
      "change": _vm.handleRegionSearch
    },
    model: {
      value: (_vm.checkedRegions),
      callback: function($$v) {
        _vm.checkedRegions = $$v
      },
      expression: "checkedRegions"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "infinite-list-wrapper"
  }, [_c('ul', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetch),
      expression: "fetch"
    }],
    staticClass: "store-list",
    attrs: {
      "infinite-scroll-disabled": "disabled"
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('li', {
      staticClass: "store-list-item",
      class: _vm.multiple ? _vm.current.findIndex(function (cur) { return cur.id === item.id; }) !== -1 ? 'active' : '' : _vm.current.id === item.id ? 'active' : '',
      on: {
        "click": function($event) {
          return _vm.handleItemClick(item)
        }
      }
    }, [_c('div', {
      staticClass: "store-name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "store-address"
    }, [_vm._v(_vm._s(item.address))])])
  }), 0), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('i', {
    staticClass: "el-icon-loading"
  }), _vm._v(" 加载中...")]) : _vm._e(), _vm._v(" "), (_vm.noMore) ? _c('div', {
    staticClass: "content-padded content-center muted"
  }, [_vm._v("没有更多了")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b9b4116c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b9b4116c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/function/storeList.vue
// module id = 2916
// module chunks = 0